import PropTypes from 'prop-types'

/**
 * @typedef {Object} CameraTelemetry
 * @property {string} [cameraId]                           - camera id.
 * @property {boolean} [accelerometerCalibrationCompleted] - indicates accelerometer calibration is completed.
 * @property {boolean} [adasCalibrationReady]              - indicates ADAS calibration is ready.
 * @property {boolean} [adasCalibrationCompleted]          - indicates ADAS calibration is completed.
 */
export const cameraTelemetryPropType = PropTypes.shape({
    cameraId: PropTypes.string,
    accelerometerCalibrationCompleted: PropTypes.bool,
    adasCalibrationReady: PropTypes.bool,
    adasCalibrationCompleted: PropTypes.bool
})
